"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCondition = exports.Condition = exports.QueryFieldValue = void 0;
class QueryFieldValue {
    constructor(o = {}) {
        this.id = o.id || [];
        this.title = o.title || [];
        this.from = o.from || '';
        this.to = o.to || '';
        this.color = o.color || [];
        this.delay = o.delay || 30;
        this.delayUnit = o.delayUnit || 'minute';
        this.valueUnit = o.valueUnit || 'day';
        this.repetition = o.repetition === null || o.repetition === undefined ? 0 : o.repetition;
        this.repetitionUnit = o.repetitionUnit || 'day';
        this.cooldown = o.cooldown || 1;
        this.cooldownUnit = o.cooldownUnit || 'hour';
    }
}
exports.QueryFieldValue = QueryFieldValue;
class Condition {
    constructor(o = {}) {
        this.queryFieldKey = o.queryFieldKey;
        this.operator = o.operator;
        this.value = new QueryFieldValue(o.value);
    }
}
exports.Condition = Condition;
class WorkflowCondition {
    /* CONSTRUCTOR */
    constructor(o = {}) {
        this.andConditions = o.andConditions || [];
    }
}
exports.WorkflowCondition = WorkflowCondition;
exports.default = WorkflowCondition;
